﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateDashboard = void 0;
const com = require("../com/tmpls");
const StatePaged_1 = require("./abstracts/StatePaged");
const L = require("leaflet");
class StateDashboard extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageDashboard, "Dashboard", true);
        this._markers = [];
    }
    start() {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return _super.start.call(this);
        });
    }
    afterStart() {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.afterStart.call(this);
            this._map = L.map('map').setView([48.142723, 11.576843], 10);
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 19,
                attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            }).addTo(this._map);
            yield this._refresh();
        });
    }
    _refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            let vehicles = yield this.lockgui(this.app.api.admin.activeManager.getActiveVehicles(0, 1000));
            if (!vehicles)
                return;
            let icon = L.icon({
                iconUrl: 'images/icons/map-pin_driver.svg',
                iconSize: [30, 60],
                iconAnchor: [15, 45]
            });
            for (const m of this._markers)
                m.removeFrom(this._map);
            this._markers = [];
            for (const d of vehicles)
                this._markers.push(L.marker(d.coordinates, { icon: icon }).addTo(this._map));
        });
    }
}
exports.StateDashboard = StateDashboard;
StateDashboard.StateName = "dashboard";
//# sourceMappingURL=StateDashboard.js.map